import React from 'react';
import { Layout } from 'fronton-react';
import { productCard } from './pdp-styles';

type PDPProps = {
  children: React.ReactNode;
  productMedia: React.ReactNode;
  productInfo: React.ReactNode;
};

export const Pdp: React.FC<PDPProps> = ({ children, productMedia, productInfo }) => (
  <div itemScope itemType="https://schema.org/Product">
    <Layout>
      <div className={productCard}>
        {productMedia}
        {productInfo}
      </div>
    </Layout>
    {children}
  </div>
);
